export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';

export default { STATE_INIT, DEFAULT_ASSIGN, SEARCH_PARAM };
